<template>
  <div class="fullpage">
    <!-- 顶部全屏图片：移动端用750_375.jpg -->
    <div ref="topSection" class="top-img-section">
      <img :src="topImgSrc" alt="顶部大图" class="top-img" />
      <!-- 移动端顶部大图悬浮标题和slogan -->
      <!-- <div class="mobile-topimg-overlay">
        <img src="../assets/标题.png" alt="标题" class="mobile-title-img" />
        <img src="../assets/slogan.png" alt="slogan" class="mobile-slogan-img" />
      </div> -->
    </div>

    <!-- 预留后续图片区域 -->
    <div ref="contentSection" class="img-section">
      <img :src="sectionImgSrc" alt="图片11" style="max-width:100vw;max-height:200vh;object-fit:contain;" />
    </div>

    <!-- 移动端内容区域 -->
    <div class="HomeContent">
      <!-- 品牌起源文字区域 -->
      <div class="mid">
        <p style="color: rgb(117, 71, 28);font-size: 25px ;text-align: center;">{{ t('brand.origin.title') }}</p>
        <p class="desc-p">{{ t('brand.origin.text') }}</p>
      </div>
      
      <!-- Footer只在移动端显示 -->
              <div class="footer">
          <p>{{ t('contact.booking') }}</p>
          <p>{{ t('contact.franchise') }}</p>
          <p>{{ t('contact.franchise.email') }}</p>
          <p v-if="isEnglish">{{ t('contact.holiday') }}</p>
        </div>
      <div class="qrcode-row">
        <div class="qrcode-item">
          <img src="../assets/公众号.png" alt="官方公众号" class="qrcode-img" />
          <div class="qrcode-label">{{ t('qrcode.wechat') }}</div>
        </div>
        <div class="qrcode-item">
          <img src="../assets/加盟申请.png" alt="加盟申请" class="qrcode-img" />
          <div class="qrcode-label">{{ t('qrcode.apply') }}</div>
        </div>
        <div class="qrcode-item">
          <img src="../assets/店长招聘.png" alt="店长招聘" class="qrcode-img" />
          <div class="qrcode-label">{{ t('qrcode.hire') }}</div>
        </div>
        <div class="qrcode-item">
          <img src="../assets/小程序.png" alt="官方小程序" class="qrcode-img" />
          <div class="qrcode-label">{{ t('qrcode.mini') }}</div>
        </div>
      </div>
    </div>
    
    <!-- ICP备案号 -->
    <div class="icp-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-link">
        沪ICP备12026753号
      </a>
    </div>
  </div>
</template>

<script>
import topImgMobile from '../assets/750_375.jpg'
import sectionImgMobile from '../assets/竖版.jpg'
// 使用新的 i18n-x.js 进行移动端翻译
import { t } from '../i18n-x'

export default {
  name: 'HomeViewMobile',
  data() {
    return {
      topImgSrc: topImgMobile,
      sectionImgSrc: sectionImgMobile,
      isScrolling: false,
      scrollTimeout: null,
      lastScrollTime: 0,
      scrollDirection: 'none',
      touchStartTime: 0,
      touchEndTime: 0,
    }
  },
  computed: {
    isEnglish() {
      return document.documentElement.getAttribute('lang') === 'en';
    }
  },
  mounted() {
    this.initScrollHandlers();
    this.initTouchHandlers();
  },
  beforeDestroy() {
    this.cleanupEventListeners();
  },
  methods: {
    // 国际化函数
    t,
    // 初始化滚动处理器
    initScrollHandlers() {
      // 移动端滚动处理 - 显示完整正文内容
      this.mobileScrollHandler = this.throttle(() => {
        if (this.isScrolling) return;
        
        const topImg = document.querySelector('.top-img');
        const firstImgSection = document.querySelector('.img-section');
        const midSection = document.querySelector('.mid');
        if (!topImg || !firstImgSection) return;
        
        const rect = topImg.getBoundingClientRect();
        const imgSectionRect = firstImgSection.getBoundingClientRect();
        const currentScrollTop = window.pageYOffset;
        const currentTime = Date.now();
        
        // 检测滚动方向和速度
        const isScrollDown = currentScrollTop > (this.lastScrollTop || 0);
        const scrollSpeed = Math.abs(currentScrollTop - (this.lastScrollTop || 0));
        this.scrollDirection = isScrollDown ? 'down' : 'up';
        
        // 智能检测：避免在用户快速滚动时触发
        const timeSinceLastScroll = currentTime - (this.lastScrollTime || 0);
        const isUserActivelyScrolling = timeSinceLastScroll < 100 && scrollSpeed > 10;
        
        // 移动端：下滑时显示完整品牌起源文字
        if (isScrollDown && rect.top <= 80 && rect.top >= -120 && !isUserActivelyScrolling) {
          if (scrollSpeed > 5) {
            if (midSection) {
              this.quickScrollToElement(midSection, 'bottom');
            } else {
              this.quickScrollToElement(firstImgSection, 'top');
            }
          } else {
            if (midSection) {
              this.smoothScrollToElement(midSection, 'bottom');
            } else {
              this.smoothScrollToElement(firstImgSection, 'top');
            }
          }
        }
        // 上滑：第一个图片区域顶部接近视口顶部时回到顶部
        else if (!isScrollDown && imgSectionRect.top >= -80 && imgSectionRect.top <= 120 && !isUserActivelyScrolling) {
          if (scrollSpeed > 5) {
            this.quickScrollToTop();
          } else {
            this.smoothScrollToTop();
          }
        }
        
        this.lastScrollTop = currentScrollTop;
        this.lastScrollTime = currentTime;
      }, 8);
      
      // 绑定事件监听器
      window.addEventListener('scroll', this.mobileScrollHandler, { passive: true });
    },
    
    // 初始化触摸处理器
    initTouchHandlers() {
      this.touchStartY = 0;
      this.touchStartX = 0;
      this.touchStartTime = 0;
      this.touchEndY = 0;
      this.touchEndX = 0;
      this.touchEndTime = 0;
      this.isTouching = false;
      this.touchVelocities = [];
      this.lastTouchTime = 0;
      this.lastTouchY = 0;
      
      const topSection = this.$refs.topSection;
      if (topSection) {
        topSection.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        topSection.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        topSection.addEventListener('touchend', this.handleTouchEnd, { passive: true });
      }
    },
    
    // 清理事件监听器
    cleanupEventListeners() {
      window.removeEventListener('scroll', this.mobileScrollHandler);
      
      const topSection = this.$refs.topSection;
      if (topSection) {
        topSection.removeEventListener('touchstart', this.handleTouchStart);
        topSection.removeEventListener('touchmove', this.handleTouchMove);
        topSection.removeEventListener('touchend', this.handleTouchEnd);
      }
    },
    
    // 触摸开始处理
    handleTouchStart(e) {
      this.isTouching = true;
      this.touchStartY = e.touches[0].clientY;
      this.touchStartX = e.touches[0].clientX;
      this.touchStartTime = Date.now();
    },
    
    // 触摸移动处理
    handleTouchMove(e) {
      if (!this.isTouching) return;
      
      const currentY = e.touches[0].clientY;
      const currentX = e.touches[0].clientX;
      const currentTime = Date.now();
      const deltaY = Math.abs(currentY - this.touchStartY);
      const deltaX = Math.abs(currentX - this.touchStartX);
      
      // 计算触摸速度
      if (this.lastTouchTime > 0) {
        const timeDelta = currentTime - this.lastTouchTime;
        const distanceDelta = Math.abs(currentY - this.lastTouchY);
        if (timeDelta > 0) {
          const velocity = distanceDelta / timeDelta;
          this.touchVelocities.push(velocity);
          if (this.touchVelocities.length > 5) {
            this.touchVelocities.shift();
          }
        }
      }
      
      this.lastTouchTime = currentTime;
      this.lastTouchY = currentY;
      
      // 如果水平滑动距离大于垂直滑动距离，阻止默认行为
      if (deltaX > deltaY && deltaX > 10) {
        e.preventDefault();
      }
    },
    
    // 触摸结束处理
    handleTouchEnd(e) {
      if (!this.isTouching) return;
      
      this.isTouching = false;
      this.touchEndY = e.changedTouches[0].clientY;
      this.touchEndX = e.changedTouches[0].clientX;
      this.touchEndTime = Date.now();
      
      this.handleSwipe();
    },
    
    // 处理滑动手势
    handleSwipe() {
      const deltaY = this.touchEndY - this.touchStartY;
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaTime = this.touchEndTime - this.touchStartTime;
      
      // 确保是垂直滑动且时间合理
      if (Math.abs(deltaY) < Math.abs(deltaX) || deltaTime < 50 || deltaTime > 1500) {
        return;
      }
      
      // 计算平均触摸速度
      const avgVelocity = this.touchVelocities.length > 0 
        ? this.touchVelocities.reduce((a, b) => a + b, 0) / this.touchVelocities.length 
        : 0;
      
      const swipeThreshold = window.innerHeight * 0.15;
      const velocity = Math.abs(deltaY) / deltaTime;
      const combinedVelocity = Math.max(velocity, avgVelocity);
      
      // 移动端：向上滑动显示完整品牌起源文字
      if (Math.abs(deltaY) > swipeThreshold || combinedVelocity > 0.4) {
        if (deltaY < 0) {
          // 向上滑动：跳转到品牌起源文字底部
          const midSection = document.querySelector('.mid');
          
          if (midSection) {
            if (combinedVelocity > 0.8) {
              this.quickScrollToElement(midSection, 'bottom');
            } else {
              this.smoothScrollToElement(midSection, 'bottom');
            }
          } else {
            const firstImgSection = document.querySelector('.img-section');
            if (firstImgSection) {
              if (combinedVelocity > 0.8) {
                this.quickScrollToElement(firstImgSection, 'top');
              } else {
                this.smoothScrollToElement(firstImgSection, 'top');
              }
            }
          }
        } else {
          // 向下滑动：回到顶部
          if (combinedVelocity > 0.8) {
            this.quickScrollToTop();
          } else {
            this.smoothScrollToTop();
          }
        }
      }
      
      // 清理速度历史
      this.touchVelocities = [];
    },
    
    // 平滑滚动到元素
    smoothScrollToElement(element, position = 'top') {
      if (this.isScrolling) return;
      
      this.isScrolling = true;
      const rect = element.getBoundingClientRect();
      let targetScrollTop;
      
      if (position === 'top') {
        targetScrollTop = window.pageYOffset + rect.top;
      } else if (position === 'bottom') {
        targetScrollTop = window.pageYOffset + rect.bottom - window.innerHeight;
      } else {
        targetScrollTop = window.pageYOffset + rect.top + rect.height / 2 - window.innerHeight / 2;
      }
      
      this.performSmoothScroll(targetScrollTop);
    },
    
    // 平滑滚动到顶部
    smoothScrollToTop() {
      if (this.isScrolling) return;
      
      this.isScrolling = true;
      this.performSmoothScroll(0);
    },
    
    // 快速滚动到元素
    quickScrollToElement(element, position = 'top') {
      if (this.isScrolling) return;
      
      this.isScrolling = true;
      const rect = element.getBoundingClientRect();
      let targetScrollTop;
      
      if (position === 'top') {
        targetScrollTop = window.pageYOffset + rect.top;
      } else if (position === 'bottom') {
        targetScrollTop = window.pageYOffset + rect.bottom - window.innerHeight;
      } else {
        targetScrollTop = window.pageYOffset + rect.top + rect.height / 2 - window.innerHeight / 2;
      }
      
      this.performQuickScroll(targetScrollTop);
    },
    
    // 快速滚动到顶部
    quickScrollToTop() {
      if (this.isScrolling) return;
      
      this.isScrolling = true;
      this.performQuickScroll(0);
    },
    
    // 执行快速滚动
    performQuickScroll(targetScrollTop) {
      const startScrollTop = window.pageYOffset;
      const distance = targetScrollTop - startScrollTop;
      const duration = Math.min(Math.abs(distance) * 0.4, 400);
      const startTime = performance.now();
      
      const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);
      
      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeOutQuart(progress);
        
        window.scrollTo(0, startScrollTop + distance * easedProgress);
        
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        } else {
          setTimeout(() => {
            this.isScrolling = false;
          }, 50);
        }
      };
      
      requestAnimationFrame(animateScroll);
    },
    
    // 执行平滑滚动
    performSmoothScroll(targetScrollTop) {
      const startScrollTop = window.pageYOffset;
      const distance = targetScrollTop - startScrollTop;
      const duration = Math.min(Math.abs(distance) * 0.6, 600);
      const startTime = performance.now();
      
      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
      
      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeOutCubic(progress);
        
        window.scrollTo(0, startScrollTop + distance * easedProgress);
        
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        } else {
          setTimeout(() => {
            this.isScrolling = false;
          }, 50);
        }
      };
      
      requestAnimationFrame(animateScroll);
    },
    
    // 节流函数
    throttle(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    },
  },
}
</script>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  background-color: rgb(255, 248, 237);
}

.fullpage {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  background: rgb(255, 248, 237);
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.top-img {
  width: 100%;
  height: 100vh;
  max-width: 100vw;
  object-fit: cover;
  object-position: center top;
  display: block;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  will-change: transform;
}

.img-section {
  width: 100%;
  min-height: 200px;
  background-color: rgb(255, 248, 237);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  padding: 0;
  touch-action: pan-y;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.img-section img {
  width: 100%;
  max-width: 100vw;
  height: auto;
  object-fit: contain;
  display: block;
  max-height: 40vh;
}

.img-section:last-child {
  margin-bottom: 0px;
}

.top-img-section {
  touch-action: pan-y;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  will-change: transform;
}

.mobile-topimg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.mobile-title-img {
  margin-top: 120px;
  width: 60vw;
  max-width: 320px;
  height: auto;
  display: block;
}

.mobile-slogan-img {
  position: absolute;
  left: 50%;
  bottom: 150px;
  transform: translateX(-50%);
  width: 70vw;
  max-width: 340px;
  height: auto;
  display: block;
}

.HomeContent {
  width: 80vw;
  margin: 0 auto;
  box-sizing: border-box;
}

.mid {
  position: relative;
  height: auto;
  background-color: rgb(255, 248, 237);
  text-align: center;
}

.desc-p {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: block;
  text-align: justify;
  letter-spacing: 2px;
  line-height: 2.2;
  margin-top: 10px;
  font-size: 13px;
  color: #555;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  font-family: Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  white-space: pre-wrap;
}

/* 品牌描述样式 - 英文（仅影响英文，不改变中文） */
html[lang="en"] .desc-p {
  font-family: "Inter", "SF Pro Text", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0.15px;
  word-spacing: 0px;
  text-align: justify !important;
  text-justify: distribute;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  hyphens: auto;
  -webkit-hyphens: auto;
  overflow-wrap: break-word;
  word-break: break-word;
}
/* 英文段落换行后的段间距增强，仅影响英文 */
html[lang="en"] .desc-p br {
  content: "";
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
@supports (text-wrap: pretty) {
  html[lang="en"] .desc-p { text-wrap: pretty; text-wrap-mode: pretty; }
}

/* 英文标题与布局微调（与中文一致：居中） */
html[lang="en"] .mid { text-align: center; }
html[lang="en"] .mid p:first-child {
  font-size: 22px;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  text-align: center !important;
}

.footer {
  width: 100%;
  position: relative;
  height: auto;
  background-color: rgb(255, 248, 237);
  text-align: center;
  max-width: 85vw;
  margin-left: 0;
  box-sizing: border-box;
}

/* 底部信息样式 - 英文（允许自动换行，避免超出屏幕） */
html[lang="en"] .footer p {
  font-family: "Inter", "SF Pro Text", Arial, sans-serif;
  letter-spacing: 0.2px;
  line-height: 1.6;
  word-spacing: 0px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
  text-align: left;
  margin: 12px 0 !important;
}

/* 英文：与中文端保持相同的区块间隔（品牌起源 → 官方预订） */
html[lang="en"] .footer { 
  margin-top: 8px !important; 
  margin-bottom: 8px !important;
  padding: 10px 0 !important;
}
html[lang="en"] .footer p:first-child { margin-top: 0; }

.footer p {
  margin-left: 0;
  box-sizing: border-box;
  letter-spacing: 1.5px;
  display: block;
  text-align: left;
  line-height: 1.4;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 9px;
  font-family: Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  white-space: nowrap;
  color: #555;
}

.footer p:first-child {
  margin-top: 40px;
}

.footer p {
  margin-top: 6px;
}

.qrcode-row {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 80vw;
  max-width: 80vw;
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(135deg, rgb(255, 248, 237) 0%, rgb(252, 245, 235) 100%);
  padding: 0px 0 20px 0;
  box-sizing: border-box;
}

.qrcode-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-row .qrcode-item:first-child {
  align-items: flex-start;
  margin-left: -10px;
}

.qrcode-row .qrcode-item:last-child {
  align-items: flex-end;
  margin-right: -10px;
}

.qrcode-row .qrcode-item:first-child .qrcode-label {
  margin-left: 9px;
}

.qrcode-row .qrcode-item:last-child .qrcode-label {
  margin-right: 8px;
}

.qrcode-img {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-top: 10px;
  margin-bottom: -7px;
}

.qrcode-label {
  text-align: center;
  font-size: 12px;
  color: #555;
  font-family: Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* 二维码标签样式 - 英文 */
html[lang="en"] .qrcode-label {
  font-family: "Inter", "SF Pro Text", Arial, sans-serif;
  letter-spacing: 0.3px;
  font-size: 11.5px;
  width: 80px;
  max-width: 80px;
  text-align: center;
  white-space: normal;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 指定英文小程序标签的连写不拆分，并在 80px 内视觉上呈单行 */
html[lang="en"] .qrcode-item:nth-child(3) .qrcode-label {
  word-break: keep-all;
  white-space: normal;
}

/* 英文：首个标签 Official Account 保持为不换行词组 */
html[lang="en"] .qrcode-item:first-child .qrcode-label {
  word-break: keep-all;
}

/* 英文：消除首尾标签的左右偏移，保证与二维码完全同心对齐 */
/* 英文保持与中文同一位置（跟随首尾偏移），文字与二维码一起移动 */
html[lang="en"] .qrcode-row .qrcode-item:first-child .qrcode-label { margin-left: 0; }
html[lang="en"] .qrcode-row .qrcode-item:last-child .qrcode-label { margin-right: 0; }

/* 移动端适配 */
@media (max-width: 768px) {
  .top-img {
    width: 100%;
    height: 100vh;
    max-width: 100vw;
    object-fit: cover;
    object-position: center top;
    display: block;
  }
  
  .img-section {
    max-width: 100vw;
    padding: 0;
  }
  
  .desc-p {
    max-width: 90vw;
    font-size: 13px;
  }

  /* 英文在窄屏的进一步优化 */
  html[lang="en"] .desc-p {
    font-size: 14px;
    line-height: 1.75;
  }
  
  .footer {
    max-width: 90vw;
  }

  html[lang="en"] .footer p {
    line-height: 1.5;
  }
  
  .qrcode-row {
    max-width: 90vw;
  }
  
  .img-section img {
    max-height: 40vh;
  }
}

@media (max-width: 480px) {
  .top-img {
    width: 100%;
    height: 100vh;
    max-width: 100vw;
    object-fit: cover;
    object-position: center top;
    display: block;
  }
  
  .img-section {
    max-width: 100vw;
    padding: 0;
  }
  
  .desc-p {
    max-width: 90vw;
    font-size: 13px;
  }

  html[lang="en"] .desc-p {
    font-size: 14px;
  }
  
  .footer {
    max-width: 90vw;
  }
  
  .qrcode-row {
    max-width: 90vw;
  }
  
  .img-section img {
    max-height: 24vh;
  }
}

/* ICP备案号样式 */
.icp-footer {
  width: 100%;
  text-align: center;
  padding: 15px 0;
  background-color: rgb(255, 248, 237);
  border-top: 1px solid #e8e8e8;
}

.icp-link {
  color: #666;
  text-decoration: none;
  font-size: 12px;
  font-family: Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  transition: color 0.3s ease;
}

.icp-link:hover {
  color: #333;
  text-decoration: underline;
}

.icp-link:active {
  color: #333;
}

/* ICP备案号样式 - 英文 */
html[lang="en"] .icp-link {
  font-family: Arial, sans-serif;
  font-size: 11px;
}
</style>

